import './locales/register'
import './page-slots'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const New = lazy(() => import('./components/New'))
const Detail = lazy(() => import('./components/Detail'))
const List = lazy(() => import('./components/List'))
const POC = lazy(() => import('./components/POC'))
const ScanCards = lazy(() => import('./components/ScanCards'))

const CustomerModule: RouteObject = {
    path: 'customers',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: 'scan-cards',
            element: <ScanCards />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
        {
            path: ':id/poc',
            element: <POC />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default CustomerModule
